import { render, staticRenderFns } from "./TextCanvas.vue?vue&type=template&id=4f064fd8"
import script from "./TextCanvas.vue?vue&type=script&lang=ts"
export * from "./TextCanvas.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports